import { render, staticRenderFns } from "./TransferLot.vue?vue&type=template&id=5dfda857"
import script from "./TransferLot.vue?vue&type=script&lang=js"
export * from "./TransferLot.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports